import React, { useMemo } from 'react'

import { useAnnotationStatusFilter } from './hooks'
import { AnnotationQueryVariablesContext } from './context'
import { AnnotationSubject } from '../../types'

interface AnnotationQueryVariablesProviderProps {
  shareIdentifier?: string
  versionIdentifier?: string
  subjects: AnnotationSubject[]
  isPreview?: boolean
}

export const AnnotationQueryVariablesProvider: React.FCC<
  AnnotationQueryVariablesProviderProps
> = ({
  children,
  subjects,
  shareIdentifier,
  versionIdentifier,
  isPreview = false,
}) => {
  const { annotationQuerySort, annotationQueryStatus } =
    useAnnotationStatusFilter()

  const value = useMemo(
    () => ({
      shareIdentifier,
      subjects,
      versionIdentifier: versionIdentifier!,
      annotationStatus: annotationQueryStatus,
      annotationSort: annotationQuerySort,
      isPreview,
    }),
    [
      annotationQuerySort,
      annotationQueryStatus,
      subjects,
      shareIdentifier,
      versionIdentifier,
      isPreview,
    ]
  )

  return (
    <AnnotationQueryVariablesContext.Provider value={value}>
      {children}
    </AnnotationQueryVariablesContext.Provider>
  )
}
